import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Static routes that map to a page_content entry.
const PAGE_CONTENT_ROUTES = {
  "/": "home_featured",
  "/news": "news",
  "/videos": "videos",
  "/stats": "stats",
  "/blast-from-the-past": "retro",
  "/spotify": "spotify",
  "/social": "social",
  "/archive": "archive",
  "/contact": "contact",
};

/**
 * Builds the right admin link for the current page, or null to hide.
 *
 * - Static content pages → /admin/page-content?focus=<id>
 * - /post/<id>           → /admin/posts/<id>/edit
 */
function resolveEditTarget(pathname) {
  if (PAGE_CONTENT_ROUTES[pathname]) {
    return `/admin/page-content?focus=${PAGE_CONTENT_ROUTES[pathname]}`;
  }
  const post = pathname.match(/^\/post\/([^/]+)$/);
  if (post) return `/admin/posts/${post[1]}/edit`;

  const customPage = pathname.match(/^\/page\/([a-z0-9-]+)$/);
  if (customPage) return `/admin/custom-pages?focus=${customPage[1]}`;

  return null;
}

export default function EditThisPageButton() {
  const { user } = useAuth();
  const { pathname, search } = useLocation();

  if (!user || user.role !== "admin") return null;
  if (new URLSearchParams(search).get("as") === "visitor") return null;

  const target = resolveEditTarget(pathname);
  if (!target) return null;

  return (
    <Link
      to={target}
      data-testid="edit-this-page-button"
      title="Edit this page"
      className="fixed bottom-6 right-6 z-50 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#0A0F17] text-white shadow-lg ring-1 ring-black/10 transition-transform hover:-translate-y-0.5"
    >
      <Pencil size={18} />
    </Link>
  );
}
